import axios from 'axios';
import { updateSessionStatus } from '../@core/actions';
import config from "../config";
import { showUserNotification } from './notification';

const API_URL = config.serviceUrl + "api/v1/";

export const buildQueryParams = (params) => {
    return "?" + Object.keys(params).map(key => key + '=' + params[key]).join('&');
}

export const restAPIHandler = {
    // post request ----------------
    post: (dispatch, serviceURL, msg, callback = (error, respose) => { console.log(error, respose) }) => {
        axios.post(API_URL + serviceURL, msg, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'csrf-token': localStorage.getItem("csrf")
            }
        }).then(response => {
            let data = response.data;
            if (data.ruleCode === 401 || data.ruleCode === 403) {
                dispatch(updateSessionStatus(true))
            }

            callback(null, data);
        }).catch(error => {
            if (error.message?.includes("401") || error.message?.includes("403")) {
                dispatch(updateSessionStatus(true))
            } else {
                showUserNotification.error(error.message);
            }
            callback(error, null);
        });
    },
    // get request ----------------
    get: (dispatch, serviceURL, msg, callback = (error, respose) => { console.log(error, respose) }) => {
        axios.get(API_URL + serviceURL + buildQueryParams(msg), {
            headers: {
                'Content-Type': 'application/json',
                'csrf-token': localStorage.getItem("csrf")
            }
        }).then(response => {
            let data = response.data
            if (data.ruleCode === 401 || data.ruleCode === 403) {
                dispatch(updateSessionStatus(true))
            }
            callback(null, data);
        }).catch(error => {
            if (error.message?.includes("401") || error.message?.includes("403")) {
                dispatch(updateSessionStatus(true))
            } else {
                showUserNotification.error(error.message);
            }
            callback(error, null);
        });
    }
}
